const DEFAULT_TAB = {page: 'homePage', tab: 0};

const getTabItemInfo = page => {
  const {widgetSetting: settings} = window.AVADA_FAQ;
  const options = [
    'homePage',
    settings.isLiveChat && 'chatDetail',
    settings.isOrderTracking && 'trackTab',
    (settings.isFeaturedArticles || settings.isCategory) && 'categoriesList'
  ].filter(Boolean);
  const indexTab = options.indexOf(page);
  if (indexTab !== -1) return {page, tab: indexTab};
  return DEFAULT_TAB;
};

export const getCurrentTabInfo = section => {
  switch (section) {
    case '#chatty-chat':
      return getTabItemInfo('chatDetail');
    case '#chatty-tracking':
      return getTabItemInfo('trackTab');
    case '#chatty-help':
      return getTabItemInfo('categoriesList');
    default:
      return DEFAULT_TAB;
  }
};
